import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { Logo } from '../brand/Logo';
import { Button } from '../ui/Button';
import { NavDropdown } from './NavDropdown';
import { MobileMenu } from './MobileMenu';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => setMobileOpen(false), [location.pathname, location.hash]);
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    if (!mobileOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setMobileOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [mobileOpen]);
  return <header className={`sticky top-0 z-50 border-b transition-[background-color,border-color,box-shadow] duration-200 ${scrolled ? 'border-white/10 bg-midnight shadow-lift' : 'border-transparent bg-midnight'}`} data-id="element-412" data-mp="gmje1cjesmvl">
      <div className="container-page flex h-[76px] items-center justify-between gap-6" data-id="element-413" data-mp="3k4jmstwsgwa9">
        <Logo data-id="element-414" data-mp="3p3e39p7aa8r7" />
        <nav aria-label="Main" className="hidden items-center xl:flex" data-id="element-415" data-mp="3p34m8r47vbxn">
          <ul className="flex items-center gap-0.5" data-id="element-416" data-mp="3tz35y1elo5rq">
            {mainNav.map(item => <li key={item.label} data-id="element-417" data-mp="1y58gtulykbc">
                {item.children ? <NavDropdown item={item} data-id="element-418" data-mp="1994140suqctc" /> : <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block rounded-md px-3 py-2 text-sm transition-colors duration-150 ${isActive ? 'text-gold-300' : 'text-white/80 hover:text-white'}`} data-id="element-419" data-mp="1dbr0qnvrl213">
                    {item.label}
                  </NavLink>}
              </li>)}
          </ul>
        </nav>
        <div className="flex items-center gap-3" data-id="element-420" data-mp="3ec5nfzsy2o6v">
          <Button to="/employers" size="sm" className="hidden sm:inline-flex" data-id="element-421" data-mp="2qpfleyglitm9">
            Hire Talent
          </Button>
          <button type="button" className="rounded-md p-2 text-white xl:hidden" aria-expanded={mobileOpen} aria-controls="mobile-menu" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} onClick={() => setMobileOpen(o => !o)} data-id="element-422" data-mp="2modhw5fnbveh">
            {mobileOpen ? <XIcon className="h-6 w-6" data-id="element-423" data-mp="27vjvs15vch0u" /> : <MenuIcon className="h-6 w-6" data-id="element-424" data-mp="22zlaimfu7f4n" />}
          </button>
        </div>
      </div>
      <AnimatePresence data-id="element-425" data-mp="ih0xgv66exrz">{mobileOpen && <MobileMenu id="mobile-menu" data-id="element-426" data-mp="ifzc9xvg4uwj" />}</AnimatePresence>
    </header>;
}